import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {CardFormComponent} from '../../../card-form/card-form.component';
import {GuestActivityFormComponent} from '../activity-form/activity-form.component';
import {DeleteAttendeeWarningComponent} from '../../../delete-attendee-warning/delete-attendee-warning.component';
import {PayBalanceComponent} from '../../../pay-balance/pay-balance.component';
import {MdDialog, MdSnackBar,MdDialogRef,MdSnackBarConfig} from '@angular/material';
import {EventService} from '../../../admin/event.service';
import {UserService} from '../../../common/user.service';
import {PackageService} from '../../../common/package.service';
import {CardService} from '../../../common/card.service';
import {GuestAttendeeFormComponent} from '../attendee-form/attendee-form.component';
import { EditGuestAttendeeComponent } from '../edit-attendee/edit-attendee.component';
import { EditTravelComponent } from '../../../edit-travel/edit-travel.component';
import {ChangeAdminPasswordComponent} from '../../../admin/profile/change-password/change-admin-password.component';
import {AuthenticationService} from '../../../auth/authentication.service';
import { Router } from '@angular/router';
import { AppSettings } from '../../../app-settings'

@Component({
  selector: 'guest-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css', '../../../app.component.css'],
  providers: [ EventService , UserService , PackageService, CardService ]
})
export class GuestProfileComponent implements OnInit {

  public userInfo = JSON.parse(localStorage.userInfo);
  public users = [];
  public events = [];
  public eventId = 0;
  public event: any;
  public package: any;
  public cards = [];
  public spinner: boolean = false;
  errorMessage: any;
  profile: any;
  balanceDue:any=0;

    CONTACT_EMAIL = AppSettings.CONTACT_EMAIL
    CONTACT_NAME = AppSettings.CONTACT_NAME

  constructor(public dialog: MdDialog, private eventService: EventService, private userService: UserService, private titleService: Title, private packageService: PackageService, private cardService: CardService, private snackBar: MdSnackBar, public auth: AuthenticationService, private router: Router){
   this.dialog.afterAllClosed.subscribe(() => {
    this.getEvents();
   });
  }

  ngOnInit() {
   this.titleService.setTitle('Staff / Guest Profile');
   this.getEvents();
   this.getCards();
  }

  getEvents(){
   this.eventService.getEvents({}).subscribe(response => {
    this.events = response;
    for(var i=0;i<this.events.length;i++)
    {
     this.events[i].id = parseInt(this.events[i].id);
     this.events[i].reg_ended = parseInt(this.events[i].reg_ended);
     this.events[i].obtainTravel = parseInt(this.events[i].obtainTravel);
     if(this.events[i].isCurrentEvent==1){
        this.eventId=parseInt(this.events[i].id)
      }
    }
    this.eventSelected();
   });
  }

  getCards(){
   this.spinner = true;
   this.cardService.getCards(this.userInfo.userId).subscribe(
    response => {
     this.spinner = false;
     this.cards = response;
    },
    error => {
     this.spinner = false;
    }
   );
  }

    phoneFormat(phone){
        if(phone && phone!='')
            return (phone).replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }

  cardFormDialog(card) {
    let dialogRef = this.dialog.open(CardFormComponent);
      dialogRef.componentInstance.users = this.users[0];
      if(card)
          dialogRef.componentInstance.creditCard = card;
      else
          dialogRef.componentInstance.creditCard ='';
    dialogRef.componentInstance.onSave.subscribe(() => {
     this.getCards();
     dialogRef.close();
    });
  }

  activityFormDialog(params) {
   let dialogRef = this.dialog.open(GuestActivityFormComponent);
   dialogRef.componentInstance.eventId = this.eventId;
   dialogRef.componentInstance.packageId = this.package.id;
   dialogRef.componentInstance.users = this.users;
   dialogRef.componentInstance.event = this.event;
   dialogRef.componentInstance.cards = this.cards;
   dialogRef.componentInstance.creditCard.existing = (this.cards.length>0 ? true : false);
   dialogRef.componentInstance.userIndex = params.userIndex;
   dialogRef.componentInstance.currentActivity = dialogRef.componentInstance.users[params.userIndex].eventUser.userActivity.activityId;
   dialogRef.componentInstance.initiate();
   dialogRef.componentInstance.onSave.subscribe(() => {
    this.getEvents();
    this.getCards();
    dialogRef.close();
   });
   dialogRef.componentInstance.onClose.subscribe(() => {
    this.getEvents();
    dialogRef.close();
   });
  }

  deleteAttendeeWarningDialog() {
    let dialogRef = this.dialog.open(DeleteAttendeeWarningComponent);
  }

  payBalanceDialog() {
    let dialogRef = this.dialog.open(PayBalanceComponent);
  }

  eventSelected(){
   this.spinner = true;
   this.users = [];
   this.package = undefined;
   for(var i=0;i<this.events.length;i++)
   if(this.events[i].id==this.eventId)
   {
    this.event = this.events[i];
    break;
   }
   this.userService.guestProfile({userId:this.userInfo.userId, eventId:this.eventId,eventUserId:this.userInfo.eventUserId}).subscribe(
    response => {
     this.spinner = false;
     this.users = response.users;
     this.profile=response;
     this.balanceDue=(response.bal)?response.bal:0;
    if(this.users[0].eventUser)
     this.packageService.findPackage(this.users[0].eventUser.packageId).subscribe(response => {
      this.package = response[0];
     });
    },
    error => {
     this.spinner = false;
    }
   );
  }

  usDateTimeFormat(dt){
   if(dt)
   {
    if(typeof dt=='string')
    {
     dt = dt.split(' ');
     dt = dt[0].split('-');
     return dt[1]+'/'+dt[2]+'/'+dt[0];
    }
    else
    {
     var m = dt.getMonth()+1;
     if(m<10)
     m='0'+m;
     var d = dt.getDate();
     if(d<10)
     d='0'+d;
     return m+'/'+d+'/'+dt.getFullYear();
    }
   }
   else
   return '';
  }

    getFinalTotal(){
        if(this.users[0].eventUser.totalPrice>0){
            var fTotal:any =0;
            fTotal= parseFloat(this.users[0].eventUser.totalPrice)-(parseFloat(this.users[0].eventUser.discount)+parseFloat(this.profile.refundAmount[0].refundAmount));
            return (fTotal>0)?fTotal:0;
        }
        return 0;
    }

  attendeeFormDialog() {
      let addAttendee: MdDialogRef<GuestAttendeeFormComponent>;
      addAttendee= this.dialog.open(GuestAttendeeFormComponent);
      addAttendee.componentInstance.userId = this.userInfo.userId;
      addAttendee.componentInstance.eventId = this.eventId;
      addAttendee.componentInstance.userType=this.userInfo.type;
      addAttendee.componentInstance.eventUserId=this.userInfo.eventUserId;
      addAttendee.componentInstance.mainUser=this.users[0];
      addAttendee.afterClosed()
          .subscribe(
              response => {
              if (response) {
                  this.getEvents();
                  this.getCards();
              }
          },
              error => {
              this.errorMessage = <any>error;
          }
      );
  }

    editAttendee(userId,counts) {
        let editAttendee: MdDialogRef<EditGuestAttendeeComponent>;
        editAttendee= this.dialog.open(EditGuestAttendeeComponent);
        editAttendee.componentInstance.userId = userId;
        editAttendee.componentInstance.eventId = this.eventId;
        editAttendee.componentInstance.eventUserId=this.userInfo.eventUserId;
        editAttendee.componentInstance.counts=counts;
        editAttendee.afterClosed()
            .subscribe(
                response => {
                if (response==true) {
                    this.getEvents();
                    this.getCards();
                    this.userInfo=JSON.parse(localStorage.userInfo);
                }
            },
                error => {
                this.errorMessage = <any>error;
            }
        );
    }

    editTravelInfo(info){
        let editTravel: MdDialogRef<EditTravelComponent>;
        editTravel= this.dialog.open(EditTravelComponent);
        editTravel.componentInstance.Info = info;
        editTravel.afterClosed()
            .subscribe(
                response => {
                if (response) {
                    this.getEvents();
                    this.getCards();
                }
            },
                error => {
                this.errorMessage = <any>error;
            }
        );
    }

  deleteCard(card){
   if(confirm('Are you sure?'))
   {
    this.spinner = true;
    this.cardService.deleteCard(card).subscribe(
     response => {
      this.spinner = false;
      this.snackBar.open('Card deleted successfully', '', {duration: 4000});
      this.getCards();
     },
     error => {
      this.spinner = false;
      this.snackBar.open(error, '', {duration: 4000});
     }
    );
   }
  }

    getBalance(){
        //var totalAmt:any =0;
        //var balance:any =0;
        //totalAmt=parseFloat(this.users[0].eventUser.totalPrice)-(parseFloat(this.profile.refundAmount[0].refundAmount)+parseFloat(this.users[0].eventUser.discount));
        //
        //if(this.profile.dummyRefund[0].dummyRefund>0){
        //    balance=(totalAmt+(parseFloat(this.profile.refundAmount[0].refundAmount)-parseFloat(this.profile.dummyRefund[0].dummyRefund)))-(parseFloat(this.profile.cardPaid[0].total)+parseFloat(this.profile.checkPaid[0].total));
        //}else{
        //    balance=(totalAmt+(parseFloat(this.profile.refundAmount[0].refundAmount)))-(parseFloat(this.profile.cardPaid[0].total)+parseFloat(this.profile.checkPaid[0].total));
        //}
        //if(balance<0){
        //    balance= parseFloat(this.users[0].eventUser.totalPrice)-(parseFloat(this.profile.cardPaid[0].total)+parseFloat(this.profile.checkPaid[0].total)+parseFloat(this.profile.dummyRefund[0].dummyRefund))
        //}
        //(balance>0)?balance:0;
        //this.balanceDue=(balance).toFixed(2);
        //return (balance).toFixed(2);
    }

    payBalance(userId,eventId,type) {
        let payBalance: MdDialogRef<PayBalanceComponent>;
        payBalance= this.dialog.open(PayBalanceComponent);

        payBalance.componentInstance.userId = userId;
        payBalance.componentInstance.eventId = eventId;
        payBalance.componentInstance.type=type;
        payBalance.componentInstance.balance = (this.balanceDue)?this.balanceDue:0;
        payBalance.componentInstance.oldCards =this.cards;
        payBalance.componentInstance.mainUser =this.users[0];
        payBalance.componentInstance.eventUserId=this.userInfo.eventUserId;
        payBalance.componentInstance.totalBalance =(this.users[0].eventUser.totalPrice)?this.users[0].eventUser.totalPrice:0;


        payBalance.afterClosed()
            .subscribe(
                response => {
                if (response.status) {
                    this.snackBar.open(response.message, '', <MdSnackBarConfig>{duration: 4000});
                    //setTimeout(()=>{ window.location.reload();}, 2000)
                    this.getEvents();
                    this.getCards();
                }
            },
                error => {
                this.errorMessage = <any>error;
            }
        );
    }

    changePasswordDialog(){
     let dialogRef = this.dialog.open(ChangeAdminPasswordComponent);
     dialogRef.componentInstance.onChangePassword.subscribe(() => {
      dialogRef.close();
      this.logout();
     });
    }

    logout() {
     this.spinner = true;
     localStorage.removeItem('eventId');
     this.auth.logout().subscribe(
      response => {
       this.spinner = false;
       if (response === true)
       this.router.navigate(['/home']);
      },
      error => {
       this.spinner = false;
      }
     );
    }

    classExists(cT){
     var cardClasses = ['mastercard', 'Mastercard', 'visa', 'Visa', 'american', 'American', 'american-express', 'amex', 'Amex', 'cirrus', 'Cirrus', 'dankort', 'Dankort', 'dinners', 'Dinners', 'discover', 'Discover', 'electron', 'Electron', 'jcb', 'Jcb', 'maestro', 'Maestro', 'paypal', 'Paypal', 'unionpay', 'Unionpay'];
     //return cardClasses.includes(cT);
        return (cardClasses.indexOf(cT)>=0)?true:false;
    }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/guest/profile/profile/profile.component.ts